const MONTHS = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ')

export function formatDate (dateString) {
  const date = new Date(dateString)
  return (
    date.getUTCDate() +
    ' ' +
    MONTHS[date.getUTCMonth()] +
    ' ' +
    date.getUTCFullYear()
  )
}



// WEBPACK FOOTER //
// ./frontend/scripts/utils/date.js